import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Link } from 'site-modules/shared/components/link/link';

import './research-subnav.scss';

export function ResearchSubnav({
  heading = null,
  links = null,
  className = null,
  pathname = null,
  itemTrackingId = null,
}) {
  if (!links || !links.length) {
    return null;
  }

  return (
    <div className={classnames('research-subnav', className)}>
      <h2 className="heading-3 mb-1_5">{heading}</h2>
      <Row tag="ul" className="list-unstyled mb-0">
        {links.map(({ href, title }) => (
          <Col xs={6} className="mb-1" tag="li" key={`subnav-${title}`}>
            <Link
              className="subnav-item"
              to={href}
              rel={pathname === href ? 'nofollow' : undefined}
              data-tracking-id={itemTrackingId}
            >
              {title}
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}

ResearchSubnav.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  pathname: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  itemTrackingId: PropTypes.string,
};
